import { useQuery } from 'react-query';
import BookImage from '../../../../components/BookImage/BookImage';
import { environment } from '../../../../environment';
import { getBook } from '../../../../service/book';
import styles from './Book.module.scss';


export const Book = ({ bookId }) => {
  const {data:book, isFetching} = useQuery(
    ['books', bookId],
    () => getBook(bookId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false}
  );

  return(
    <section className={styles.container}>
      <div className={styles.containerImage}>
      <BookImage 
        className={styles.image} 
        path={book?.imageLink} 
        author={String(book?.author)}
        name={book?.name}
        />
      </div>
      <h1 className={styles.title}><strong>{book?.name}</strong></h1>
      <h2>{book?.author}</h2>
    </section>
  )
}